<template>
    <EDCHeader />
    <EDCHead title="Negocios del municipio" />
    <div class="municipio-businesses__body">
        <EDCServiceTypeFilter @filter_change="onFilterApplied" />
        <div class="municipio-businesses__body-content">
            <EDCEmpty message="No se han encontrado negocios de esta categoria" v-show="!businesses.length && !spinner" />
            <div class="municipio-businesses__list" v-show="businesses.length && !spinner">
                <EDCBusiness 
                v-for="(business, idx) in businesses"
                :key="business.pk"
                :id="business.pk"
                :type="business.type" 
                :name="business.name" 
                :stars="parseInt(business.rating)" 
                :image="business.image || `https://picsum.photos/800/800?random=${idx}`" />
            </div>
            <nav
                v-show="totalPages > 1 && !spinner"
                class="edc-pagination"
                aria-label="Paginación de resultados"
            >
                <button
                    type="button"
                    class="edc-pagination__nav"
                    :disabled="currentPage <= 1"
                    @click="goToPage(currentPage - 1)"
                >
                    Anterior
                </button>
                <ul class="edc-pagination__pages">
                    <li v-for="p in totalPages" :key="'p-' + p">
                        <button
                            type="button"
                            class="edc-pagination__num"
                            :class="{ 'is-active': p === currentPage }"
                            :aria-current="p === currentPage ? 'page' : undefined"
                            @click="goToPage(p)"
                        >
                            {{ p }}
                        </button>
                    </li>
                </ul>
                <button
                    type="button"
                    class="edc-pagination__nav"
                    :disabled="currentPage >= totalPages"
                    @click="goToPage(currentPage + 1)"
                >
                    Siguiente
                </button>
            </nav>
        </div>
    </div>
    <EDCFooter />
    <EDCMobileNav />
</template>

<script>
import EDCHeader from '../components/Header.vue';
import EDCHead from '../components/Head.vue';
import EDCFooter from '../components/Footer.vue';
import EDCMobileNav from '../components/MobileNav.vue';
import EDCBusiness from '../components/Business.vue';
import EDCServiceTypeFilter from '../components/ServiceTypeFilter.vue';
import EDCEmpty from '../components/Empty.vue';

import { MUNICIPIO_CODES } from '../scripts/municipio-codes';
import { BusinessesAPI } from '@/services/businesses';
import { Spinner } from '@/scripts/open-spinner';
export default {
    name: "edc-municipio-businesses-view",
    components: {
    EDCHeader,
    EDCHead,
    EDCFooter,
    EDCMobileNav,
    EDCBusiness,
    EDCServiceTypeFilter,
    EDCEmpty
},
    data() {
        return {
            businesses: [],
            municipio: null,
            type_filter: 'RES',
            currentPage: 1,
            pageSize: 6,
            totalPages: 1,
            spinner: false
        }
    },
    async mounted() {
        await this.loadBusinesses({ showSpinner: true });
    },
    methods: {
        showSpinner(show) {
            this.spinner = show
        },
        async loadBusinesses(options = {}) {
            const showSpinner = options.showSpinner !== false;
            const id = parseInt(this.$route.params.id, 10);
            const municipio_idx = MUNICIPIO_CODES.findIndex((m) => m.id === id);
            const municipio = MUNICIPIO_CODES[municipio_idx];
            if (!municipio) return;

            if (showSpinner) {
                Spinner.show();
                this.showSpinner(true);
            }
            await BusinessesAPI.businessesFiltered(
                municipio.code,
                this.type_filter,
                this.currentPage
            )
                .then((data) => {
                    if (showSpinner) {
                        Spinner.hide();
                        this.showSpinner(false);
                    }
                    this.applyListResponse(data);
                })
                .catch(() => {
                    if (showSpinner) {
                        Spinner.hide();
                        this.showSpinner(false);
                    }
                });
        },
        applyListResponse(data) {
            this.businesses = data.results || [];
            if (typeof data.count === 'number') {
                this.totalPages = Math.max(1, Math.ceil(data.count / this.pageSize));
            } else {
                this.totalPages = Math.max(
                    this.currentPage,
                    this.currentPage + (data.next ? 1 : 0)
                );
            }
        },
        goToPage(p) {
            if (p < 1 || p > this.totalPages || p === this.currentPage) return;
            this.currentPage = p;
            this.loadBusinesses({ showSpinner: false });
            if (typeof window !== 'undefined') {
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        },
        onFilterApplied(type) {
            const types = {
                PLA: 'RES',
                HOS: 'HOS',
                TRA: 'TRA',
                TOU: 'TOU'
            };
            this.type_filter = types[type];
            this.currentPage = 1;
            this.businesses = [];
            this.loadBusinesses({ showSpinner: true });
        }
    }
}
</script>

<style>
/* BODY */
.municipio-businesses__body {
    width: 100%;
    max-width: 1000px;
    padding: 24px;
    margin: 0px auto;
    margin-bottom: 40px;
    display: flex;
    flex-direction: column;
    gap: 24px;
}

.municipio-businesses__municipio__list {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.municipio-businesses__body-content {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 24px;
}

.edc-pagination {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: 10px 14px;
    margin-top: 8px;
    padding: 8px 0 4px;
}

.edc-pagination__pages {
    display: flex;
    flex-wrap: wrap;
    list-style: none;
    margin: 0;
    padding: 0;
    gap: 6px;
    justify-content: center;
}

.edc-pagination__num {
    min-width: 40px;
    height: 40px;
    padding: 0 10px;
    border: 1px solid rgba(161, 83, 170, 0.28);
    border-radius: 10px;
    background: #fff;
    font-size: 0.9375rem;
    font-weight: 600;
    cursor: pointer;
    color: var(--color-dark, #222);
    transition: background 0.2s, color 0.2s, border-color 0.2s;
}

.edc-pagination__num:hover:not(.is-active) {
    border-color: var(--color-primary, #a153aa);
    color: var(--color-primary, #a153aa);
}

.edc-pagination__num.is-active {
    background: var(--color-primary, #a153aa);
    color: #fff;
    border-color: transparent;
}

.edc-pagination__nav {
    padding: 10px 16px;
    border-radius: 10px;
    border: 1px solid rgba(0, 0, 0, 0.12);
    background: #fff;
    cursor: pointer;
    font-size: 0.875rem;
    font-weight: 600;
    color: var(--color-dark, #222);
    transition: border-color 0.2s, color 0.2s;
}

.edc-pagination__nav:hover:not(:disabled) {
    border-color: var(--color-primary, #a153aa);
    color: var(--color-primary, #a153aa);
}

.edc-pagination__nav:disabled {
    opacity: 0.38;
    cursor: not-allowed;
}

.municipio-businesses__list {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(235px, 1fr));
    gap: 16px;
}
</style>